import React from 'react';
import clsx from 'clsx';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import { DARK_LIGHT, GREY, LIGHT_MODE } from '../../utils/constants';
import { makeStyles, darken } from '@material-ui/core/styles';
import useThemeQuery from '../../graphql/queries/toggle-theme';
import SelectLangage from '../header/select-language';

const useStyles = makeStyles({
    rounded: {
        borderRadius: "50%",
        border: '4px solid #ACB8D6',
        width: 150,
        height: 150,
    },
    roundedExt: {
        borderRadius: "50%",
        marginTop: -110,
        width: 170,
        height: 170,
    },
    profileText: {
        fontSize: 35,
        fontWeight: 700,
    },
    onDark: {
        color: '#fff',
    },
    name: {
        fontSize: 28
    },
    title: {
        fontSize: 20
    },
    info: {
        fontSize: 16,
        fontWeight: 300
    },
    infoTitle: {
        fontSize: 14,
        color: GREY
    },
    icon: {
        marginRight: 10,
        transition: 'all linear 200ms',
        '&:hover': {
            transform: 'scale(1.3)'
        }
    },
    greyOnDark: {
        color: GREY
    },
    description: {
        color: GREY,
        fontSize: 18
    }
})
const Profile = () => {;
    const classes = useStyles();
    const { data } = useThemeQuery();

    return (
        <Box height="100vh" display="flex" justifyContent="center" mt={15}>
            <Box bgcolor={data && data.theme? DARK_LIGHT: '#fff'} height={450} borderRadius={25} py={3} px={5} width={500}>
                <Box display="flex" justifyContent="center" >
                    <Box className={classes.roundedExt} display="flex" alignItems="center" justifyContent="center" bgcolor={data && data.theme? darken(DARK_LIGHT, 0.2): LIGHT_MODE}>
                        <Box className={classes.rounded} display="flex" alignItems="center" justifyContent="center" bgcolor={data && data.theme? DARK_LIGHT: '#fff'}>
                            <Typography className={clsx(data && data.theme? classes.greyOnDark: '', classes.profileText)}>P N</Typography>
                        </Box>                          
                    </Box>
                </Box>
                <Box display="flex" justifyContent="space-between" alignItems="center" mt={4} mb={2}>
                    <Typography className={clsx(data && data.theme? classes.onDark: '', classes.name)}>Profile Full Name</Typography>
                    <IconButton>
                        <EditIcon className={clsx(data && data.theme? classes.greyOnDark: '', classes.icon)}/>
                    </IconButton>
                </Box>
                <Box borderColor={data && data.theme? GREY: LIGHT_MODE} borderTop={1} width="100%" ></Box>
                <Box mt={5}>
                    <Box>
                        <Typography className={clsx(data && data.theme? classes.onDark: '', classes.infoTitle)}>Email: </Typography>
                        <Typography className={clsx(data && data.theme? classes.onDark: '', classes.info)}>someemailaddress@gmail.com</Typography>
                    </Box>
                    <Box mt={3}>
                        <Typography className={clsx(data && data.theme? classes.onDark: '', classes.infoTitle)}>Change langage: </Typography>
                        <Box mt={0.8}>
                            <SelectLangage fullWidth/>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default Profile;
